/**
 * Base Transition
 */
var varTransitionEnter = {
  duration: 0.56,
  ease: [0.43, 0.13, 0.23, 0.96]
};
var varTransitionExit = {
  duration: 0.36,
  ease: [0.43, 0.13, 0.23, 0.96]
};
/**
 * Wrap Enter
 */

export var varWrapEnter = {
  animate: {
    transition: {
      staggerChildren: 0.1
    }
  }
};
/**
 * Wrap Exit
 */

export var varWrapExit = {
  exit: {
    transition: {
      staggerChildren: 0.1
    }
  }
};
/**
 * Wrap Both
 */

export var varWrapBoth = {
  animate: {
    transition: {
      staggerChildren: 0.07,
      delayChildren: 0.1
    }
  },
  exit: {
    transition: {
      staggerChildren: 0.05,
      staggerDirection: -1
    }
  }
};
/**
 * Wrap Path
 */

export var varPath = {
  initial: {
    opacity: 0,
    pathLength: 0
  },
  animate: {
    opacity: 1,
    pathLength: 1,
    transition: Object.assign({}, varTransitionEnter)
  },
  exit: {
    opacity: 0,
    pathLength: 0,
    transition: Object.assign({}, varTransitionExit)
  }
};
/**
 * Hover
 */

export var varHover = {
  hover: {
    scale: 1.1
  }
};
/**
 * Click
 */

export var varSmallClick = {
  hover: {
    scale: 1.04
  },
  tap: {
    scale: 0.96
  }
};
export var varMediumClick = {
  hover: {
    scale: 1.1
  },
  tap: {
    scale: 0.9
  }
};
/**
 * Fade In
 */

export var varFadeIn = {
  initial: {
    opacity: 0
  },
  animate: {
    opacity: 1,
    transition: Object.assign({}, varTransitionEnter)
  },
  exit: {
    opacity: 0,
    transition: Object.assign({}, varTransitionEnter)
  }
};
/**
 * Fade In Right
 */

export var varFadeInRight = {
  initial: {
    x: 80,
    opacity: 0
  },
  animate: {
    x: 0,
    opacity: 1,
    transition: Object.assign({}, varTransitionEnter)
  },
  exit: {
    x: 80,
    opacity: 0,
    transition: Object.assign({}, varTransitionExit)
  }
};
/**
 * Fade In Left
 */

export var varFadeInLeft = {
  initial: {
    x: -80,
    opacity: 0
  },
  animate: {
    x: 0,
    opacity: 1,
    transition: Object.assign({}, varTransitionEnter)
  },
  exit: {
    x: -80,
    opacity: 0,
    transition: Object.assign({}, varTransitionExit)
  }
};
/**
 * Fade In Up
 */

export var varFadeInUp = {
  initial: {
    y: 80,
    opacity: 0
  },
  animate: {
    y: 0,
    opacity: 1,
    transition: Object.assign({}, varTransitionEnter)
  },
  exit: {
    y: 80,
    opacity: 0,
    transition: Object.assign({}, varTransitionExit)
  }
};
/**
 * Fade In Down
 */

export var varFadeInDown = {
  initial: {
    y: -80,
    opacity: 0
  },
  animate: {
    y: 0,
    opacity: 1,
    transition: Object.assign({}, varTransitionEnter)
  },
  exit: {
    y: -80,
    opacity: 0,
    transition: Object.assign({}, varTransitionExit)
  }
};
/**
 * Bounce
 */

export var varBounce = {
  initial: {
    y: 80,
    opacity: 0
  },
  animate: {
    y: 0,
    opacity: 1,
    transition: {
      type: 'spring',
      damping: 15,
      stiffness: 1000
    }
  },
  exit: {
    y: -80,
    opacity: 0
  }
};
/**
 * Bounce In
 */

export var varBounceIn = {
  initial: {
    scale: 1.2,
    opacity: 0
  },
  animate: {
    scale: 1,
    opacity: 1,
    transition: {
      type: 'spring',
      damping: 15,
      stiffness: 1000
    }
  }
};
/**
 * Zoom In Out
 */

export var varZoomInOut = {
  initial: {
    scale: 0.9,
    opacity: 0
  },
  animate: {
    scale: 1,
    opacity: 1,
    transition: Object.assign({
      duration: 0.5
    }, varTransitionEnter)
  },
  exit: {
    scale: 0.5,
    opacity: 0,
    transition: Object.assign({
      duration: 1.5
    }, varTransitionExit)
  }
};
/**
 * ScaleX
 */

export var varScaleX = {
  initial: {
    scaleX: 0,
    opacity: 0
  },
  animate: {
    scaleX: 1,
    opacity: 1,
    transition: Object.assign({
      duration: 0.5
    }, varTransitionEnter)
  },
  exit: {
    scaleX: 0,
    opacity: 0,
    transition: Object.assign({
      duration: 1.5
    }, varTransitionExit)
  }
};
/**
 * ScaleY
 */

export var varScaleY = {
  initial: {
    scaleY: 0,
    opacity: 0
  },
  animate: {
    scaleY: 1,
    opacity: 1,
    transition: Object.assign({
      duration: 0.5
    }, varTransitionEnter)
  },
  exit: {
    scaleY: 0,
    opacity: 0,
    transition: Object.assign({
      duration: 1.5
    }, varTransitionExit)
  }
};